import * as React from 'react';
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import NavigationBar from '../../Components/NavigationBar';
import ArabBazaar from "../../Images/WhatWeDoPictures/Cooking Images/CookingPosterJuly2022.png"
import Carousel from "react-bootstrap/Carousel";
import Aos from 'aos';
import Button from '@mui/material/Button';
import { RWebShare } from 'react-web-share';
import { green } from '@mui/material/colors';


import Box from '@mui/material/Box';
import useScrollTrigger from '@mui/material/useScrollTrigger';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import Zoom from '@mui/material/Zoom';
import Fab from '@mui/material/Fab';

function ScrollTop(props) {
  const { children, window } = props;
  // Note that you normally won't need to set the window ref as useScrollTrigger
  // will default to window.
  // This is only being set here because the demo is in an iframe.
  const trigger = useScrollTrigger({
    target: window ? window() : undefined,
    disableHysteresis: true,
    threshold: 100,
  });

  const handleClick = (event) => {
    const anchor = (event.target.ownerDocument || document).querySelector(
      '#back-to-top-anchor',
    );

    if (anchor) {
      anchor.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
    }
  };

  return (
    <Zoom in={trigger}>
      <Box
        onClick={handleClick}
        role="presentation"
        sx={{ position: 'fixed', bottom: 16, right: 16 }}
      >
        {children}
      </Box>
    </Zoom>
  );
}




const ArabianBazaar = (props) => {
    React.useEffect(() => {
        Aos.init({ duration: 100 });
    }, []);
    const buttonSx = {
        ...({
        bgcolor: green[500],
            '&:hover': {
                bgcolor: "white",
            },
    }),
    };
  return (
      <>
      <NavigationBar />
        <h1 id="back-to-top-anchor" className="ourvalues" style={{marginTop:"10px", marginBottom:"30px"}}>The first Arabian Bazaar in Rochdale</h1>
        
        <ScrollTop {...props}>
            <Fab style={{background:"gold"}} color="primary" size="small" aria-label="scroll back to top">
            <KeyboardArrowUpIcon />
            </Fab>
        </ScrollTop>
        
        <div style={{ paddingLeft: "25%", paddingRight: "25%" }}>
        <RWebShare  data={{text:"Lamet Habayeb Association", url:"https://lamethabayebassociation.org/recent-updates/Arabian-Bazaar", title: "Lamet Habayeb Association - recent updates"}}>
            <Button style={{ backgroundColor: "green", color:"white"}}>Click here to Share this event with your contacts!</Button>
        </RWebShare>
        </div>
        <div style={{backgroundImage: "linear-gradient(120deg, #fdfbfb 0%, #ebedee 100%)", padding:"20px"}}>
        <Container>
              <Row>
                  <Col md={12} sm={12} xs={12} lg={6} xl={6} data-aos="fade-up"
                      data-aos-easing="ease-in-back"
                      data-aos-delay="800"
                      data-aos-offset="0">
                      <Carousel variant="dark" className="d-block w-100" >
                          <Carousel.Item>
                              <img
                                  className="d-block w-100"
                                  src="https://scontent.flhr6-1.fna.fbcdn.net/v/t39.30808-6/292076635_758374428945816_4220602921563523678_n.jpg?stp=dst-jpg_p843x403&_nc_cat=105&ccb=1-7&_nc_sid=8bfeb9&_nc_ohc=cmahwGB0joUAX8_iw4y&_nc_ht=scontent.flhr6-1.fna&oh=00_AT9zpzsR1I5u4B01ym73ne8rlA0DM77q-5ENUW-4_p6sHQ&oe=62C9011E"
                                  alt="Second slide"
                              />
                          </Carousel.Item>
                          <Carousel.Item>
                              <img
                                  className="d-block w-100"
                                  src="https://scontent.flhr6-1.fna.fbcdn.net/v/t39.30808-6/292076635_758374428945816_4220602921563523678_n.jpg?stp=dst-jpg_p843x403&_nc_cat=105&ccb=1-7&_nc_sid=8bfeb9&_nc_ohc=cmahwGB0joUAX8_iw4y&_nc_ht=scontent.flhr6-1.fna&oh=00_AT9zpzsR1I5u4B01ym73ne8rlA0DM77q-5ENUW-4_p6sHQ&oe=62C9011E"
                                  alt="Third slide"
                              />
                          </Carousel.Item>
                          <Carousel.Item>
                              <img
                                  className="d-block w-100"
                                  src="https://scontent.flhr6-1.fna.fbcdn.net/v/t39.30808-6/292076635_758374428945816_4220602921563523678_n.jpg?stp=dst-jpg_p843x403&_nc_cat=105&ccb=1-7&_nc_sid=8bfeb9&_nc_ohc=cmahwGB0joUAX8_iw4y&_nc_ht=scontent.flhr6-1.fna&oh=00_AT9zpzsR1I5u4B01ym73ne8rlA0DM77q-5ENUW-4_p6sHQ&oe=62C9011E"
                                  alt="Third slide"
                              />
                          </Carousel.Item>
                          <Carousel.Item>
                              <img
                                  className="d-block w-100"
                                  src="https://scontent.flhr6-1.fna.fbcdn.net/v/t39.30808-6/292076635_758374428945816_4220602921563523678_n.jpg?stp=dst-jpg_p843x403&_nc_cat=105&ccb=1-7&_nc_sid=8bfeb9&_nc_ohc=cmahwGB0joUAX8_iw4y&_nc_ht=scontent.flhr6-1.fna&oh=00_AT9zpzsR1I5u4B01ym73ne8rlA0DM77q-5ENUW-4_p6sHQ&oe=62C9011E"
                                  alt="Third slide"
                              />
                          </Carousel.Item>
                          <Carousel.Item>
                              <img
                                  className="d-block w-100"
                                  src="https://scontent.flhr6-1.fna.fbcdn.net/v/t39.30808-6/292076635_758374428945816_4220602921563523678_n.jpg?stp=dst-jpg_p843x403&_nc_cat=105&ccb=1-7&_nc_sid=8bfeb9&_nc_ohc=cmahwGB0joUAX8_iw4y&_nc_ht=scontent.flhr6-1.fna&oh=00_AT9zpzsR1I5u4B01ym73ne8rlA0DM77q-5ENUW-4_p6sHQ&oe=62C9011E"
                                  alt="Third slide"
                              />
                          </Carousel.Item>
                      </Carousel>
                  </Col>
                  <Col md={12} sm={12} xs={12} lg={6} xl={6} data-aos="fade-up"
                      data-aos-easing="ease-in-back"
                      data-aos-delay="400"
                      data-aos-offset="0">
                  <Row className='text-center' style={{ paddingTop:"2%", paddingBottom: "20px" }}><b>The best of Arabian Culture!</b></Row>
                  <Row style={{paddingBottom: "10px" }}>For the first time in Rochdale, the Arab Community here at Lamet Habayeb Association, are excited to announce our very own Arab food Bazaar.</Row>

                  <Row style={{paddingBottom: "10px" }}>This forms part of our Eid preparations and we will have a variety of Arabian cuisine on offer.</Row> 

                  <Row style={{paddingBottom: "10px" }}>From amazing dishes to mouthwatering sweets, come and experience a plethora of Arabian cultures through their varying types and forms of food.</Row>

                  <Row style={{paddingBottom: "10px" }}>From Algeria, Morocco and Egypt to Palestine, Syria and Iraq, the Arab Community represents one of the most diverse communities on Earth and, in doing so, brings a wide range of delicious food that you can try.</Row>

                  <Row style={{paddingBottom: "10px" }}>So why not join us for a whole day - Friday the 8th of July from 11am to 4pm.</Row>
                  
                  <b><Row style={{paddingBottom: "10px" }}>Location: The Better Together (Old Marks and Spencer) building 54 Yorkshire Street, Rochdale, OL16 1JW</Row></b>
                  
              <b><Row style={{ paddingBottom: "10px", paddingTop: "10px" }}>Want to keep in touch and be notified of our other upcoming events?</Row></b>
              <Row style={{ paddingBottom: "10px" }}><p>You can drop us an email at <a href="mailto:lamethabayeb@yahoo.com">lamethabayeb@yahoo.com</a> to join our mailing group.</p></Row>
              <b><Row>You can also check out the variety of events, projects and activities were involved in below:</Row></b>
                  <ul>
                    <li>
                      <a href='/our-work/youth-club'>Youth Club</a>
                    </li>
                    <li>
                      <a href="/our-work/cooking-lessons">Cooking Lessons</a>
                    </li>
                    <li>
                      <a href="/our-work/wellbeing-projects">Wellbeing Projects</a>
                    </li>
                    <li>
                      <a href="/our-work/coffee-mornings">Coffee Mornings</a>
                    </li>
                    <li>
                      <a href="/our-work/lha-football-team">Lamet Habayeb Association Football Team - formally known as the <b>LHA Lions</b></a>
                    </li>
                    <li>
                      <a href="/our-work/trips">Scenic and Cultural Trips</a>
                    </li>
                    <li>
                      <a href="/our-work/walking-group">Walking Group</a>
                    </li>
                    <li>
                      <a href="/our-work/celebrations">Celebrations</a>
                    </li>
                  </ul>
                  <Row><b>You can either click on the links above to learn more or navigate to other sections of the website through the navigation bar</b></Row>
          </Col>
              </Row>
          </Container>
        </div>
        </>
  );
}

export default ArabianBazaar;